export default __webpack_public_path__ + "static/media/Edit.79ad0e35.svg";